import { IAttribute } from '@gn-audio/core/api/product-catalogue/models/attribute';
import { Component, Inject, Input, OnChanges, Output } from 'angular-ts-decorators';

import { getColorStyles, IColorStyles } from 'src/Foundation/Design/platform';

import { IProductComparisonAttribute } from "../models/product-comparison-attribute";
import { IProductComparisonAttributeOption } from "../models/product-comparison-attribute-option";
import { OnCellValueCalculate } from './models/on-cell-value-calculate';

import template from './product-comparison-cell.component.html';

@Component({
  selector: 'productComparisonCell',
  template,
})
export class ProductComparisonCellComponent implements OnChanges {
  public static $inject: ReadonlyArray<string> = ['$timeout'];

  @Input() public attribute?: IProductComparisonAttribute;
  @Input() public productAttributes?: IAttribute[];

  @Output() public onCellValueCalculate?: OnCellValueCalculate;

  public cellValue?: string;
  public cellOptions?: IProductComparisonAttributeOption[];

  constructor(@Inject('$timeout') private $timeout: ng.ITimeoutService) { }

  public ngOnChanges() {
    this.$timeout(() => { this.processCell(); });
  }

  public get isCheckmark(): boolean {
    return this.isSingleCellValue && this.cellOptions[0].value.toLowerCase() === 'true';
  }

  public get isCross(): boolean {
    return (this.isSingleCellValue && this.cellOptions[0].value.toLowerCase() === 'false') || !this.cellValue;
  }

  public get isColorAttribute(): boolean {
    return this.attribute?.name.toLowerCase() === 'product_mobcolorhex';
  }

  public getColorStyles(colorValue: string): IColorStyles {
    return getColorStyles(colorValue);
  }

  private get isSingleCellValue(): boolean {
    return this.cellOptions?.length === 1;
  }

  private processCell() {
    if (!this.attribute || !this.productAttributes) {
      return;
    }

    const options: IProductComparisonAttributeOption[] = [];

    for (const option of this.attribute.options) {
      if (this.productAttributes.some((a: IAttribute) => a.key === option.key && a.valueKey === option.value)) {
        options.push(option);
      }
    }

    this.cellOptions = options;
    this.cellValue = options.map((o: IProductComparisonAttributeOption) => o.title).join(', ');
    if (this.onCellValueCalculate) {
      this.onCellValueCalculate({ cellValue: this.cellValue });
    }
  }
}
